import { apiClient } from "@/services/apiClient";

export type ReceiptReviewStatus = "needs_review" | "mismatch" | "unverified";

export interface ReceiptReviewRow {
  checkoutId: string;
  companyId: string;
  companyName: string;
  rut: string | null;
  planId: string;
  planLabel: string;
  billingInterval: string;
  amountMinor: number;
  currency: string;
  receiptUrl: string | null;
  verificationStatus: string;
  confidence: number | null;
  read: {
    beneficiary: string | null;
    account: string | null;
    amount: number | null;
    currency: string | null;
  };
  matches: {
    account: boolean;
    name: boolean;
    amount: boolean;
    currency: boolean;
  } | null;
  createdAt: string;
  paidAt: string | null;
}

export interface ListReceiptReviewsResponse {
  data: ReceiptReviewRow[];
  total: number;
}

export interface ListReceiptReviewsParams {
  page: number;
  limit: number;
  status?: ReceiptReviewStatus;
}

/** Root/ops queue of bank-transfer receipts that didn't verify clean. */
export function listReceiptReviews(
  params: ListReceiptReviewsParams,
): Promise<ListReceiptReviewsResponse> {
  return apiClient
    .get<ListReceiptReviewsResponse>("/platform/bank-transfers/reviews", {
      params: {
        page: params.page,
        limit: params.limit,
        ...(params.status ? { status: params.status } : {}),
      },
    })
    .then((res) => res.data);
}

/** Mark a flagged receipt as manually verified (clears it from the queue). */
export function resolveReceiptReview(
  checkoutId: string,
): Promise<{ ok: true; verificationStatus: string }> {
  return apiClient
    .post<{ ok: true; verificationStatus: string }>(
      `/platform/bank-transfers/reviews/${checkoutId}/resolve`,
    )
    .then((res) => res.data);
}
